<template>
  <!-- Teleport to body so draggable modal isn't constrained by TMenu parent -->
  <TDialog
    :visible="isOpen"
    :size="DialogSize.MD"
    title="Inbound Text Message Queue"
    @close="close"
  >
    <template #preTitle>
      <div class="relative mr-2">
        <TIcon
          :size="IconSize.LG"
          icon-pos="left"
          icon="chatBubble"
          class="!text-nash-purple400 p-0 w-full h-full"
        />
        <span class="text-notification-counter top-counter-position-modal">{{
          totalPointerSubtasks
        }}</span>
      </div>
    </template>
    <div>
      <p class="mb-2 text-nash-neutral700">
        {{
          subtasks?.length
            ? `${subtasks.length} Most recent open texts assigned to me`
            : 'No open texts assigned to me'
        }}
      </p>
      <div v-for="s in subtasks" :key="s.subtaskId">
        <RespondToTextSubtask :subtask="s" @close="close" />
      </div>
    </div>
  </TDialog>
</template>

<script lang="ts">
import TDialog from '@nashville/dialog/TDialog.vue'
import TIcon from '@thyme/nashville/src/components/icon/TIcon.vue'
import { defineComponent } from 'vue'
import setup from './controller'
import RespondToTextSubtask from './RespondToTextSubtask/RespondToTextSubtask.vue'
import { textingNotificationsModalProps } from './types'

export default defineComponent({
  name: 'TextingNotificationsModal',
  components: {
    TDialog,
    RespondToTextSubtask,
    TIcon,
  },
  props: textingNotificationsModalProps,
  emits: ['close'],
  setup,
})
</script>
<style lang="scss" scoped>
.top-counter-position-modal {
  // needed to vertically center number due to font and icon size differences
  top: 33%;
}
</style>
